import i18n from '../../locales/index'
import restful from '../vuex'
import axios from 'axios'
import { Message, Spin } from 'view-design'

const state = {
  ...restful.states('order'),
  repairInfo: {},
  partRefundInfo: {},
}

const getters = {
  ...restful.getters('order'),
  aggregate_test: (state) =>
    i18n.t('store_modules_mall_order_1330', [state.meta.first,state.meta.second,state.meta.third])
}

const actions = {
  ...restful.actions('orders'),
  async deliver_order ({ commit }, { id, express_no }) {
    Spin.show()
    const res = await axios.post(`orders/${id}/deliver`, { express_no })
    commit('setRecord', res.data)
    Spin.hide()
    Message.success(i18n.t('store_modules_mall_order_1331'))
  },
  async refund_order ({ commit }, params) {
    Spin.show()
    const res = await axios.post(`orders/${params.id}/merchant_accept`, {
      refund_price: params.refund_price
    })
    commit('setRecord', res.data)
    Spin.hide()
    Message.success(i18n.t('store_modules_order_1332'))
  },
  async merchant_repair ({ state }, id) {
    Spin.show()
    await axios.post(`orders/${id}/merchant_repair`, state.repairInfo)
    Spin.hide()
    Message.success(i18n.t('store_modules_order_1333'))
  },
  async part_refund ({ state }, id) {
    Spin.show()
    await axios.post(`orders/${id}/part_refund`, state.partRefundInfo)
    Spin.hide()
    Message.success(i18n.t('store_modules_order_1334'))
  },
  async call_delivery ({ commit }, id) {
    Spin.show()
    await axios.post(`orders/${id}/call_delivery`)
    Spin.hide()
    Message.success(i18n.t('store_modules_order_1335'))
  },
}

const mutations = {
  ...restful.mutations('order'),
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
